import React, { useEffect, useState } from 'react';
import { getDataTopUSer } from './api/getData';
import Report from './components/Report';

import TopUser from './components/TopUser';

import './index.css';

function App() {
  const [dataTopUser, setDataTopUser] = useState();
  useEffect(() => {
    getDataTopUSer().then((res) => {
      setDataTopUser(res?.data?.get_top_ref_user);
    });
  }, []);

  return (
    <div className='container'>
      <div className='header'>
        <img src='LocaMeet.png' alt='locameet' className='logo' />
        <div className='title'>Thống kê top user giới thiệu cao nhất</div>
      </div>
      <div className='content'>
        <div className='content-top-user'>
          {dataTopUser?.top?.map((item, index) => (
            <TopUser key={index} rank={item?.top} user={item} />
          ))}
          {/* <TopUser rank={2} />
          <TopUser rank={3} /> */}
        </div>
        <div className='statistic'>
          <Report summary={dataTopUser} />
        </div>
      </div>
    </div>
  );
}

export default App;
